<template>
    <SeatingPlan
        :numberOfSeats="53"
        :doublePlaceholderBefore="[27, 29]"
        :reorderSeats="[49, 50, 53, 51, 52]"
    />
</template>

<script lang="ts" setup>
import SeatingPlan from './SeatingPlan.vue';
</script>
